<template>
  <div class="q-gutter-sm confirmation-form">
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>お名前（姓）</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.user_name_sei }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>お名前（名）</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.user_name_mei }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>会員ID（メールアドレス）</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.mail_address }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>ご担当</label>
      </div>
      <div class="col">
        <span>{{ UserAttributeCode.getName(props.memberInfo.user_attribute) }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>勤務先／学校名</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.work_school_name }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>所属／学部名</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.affiliation_department_name }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>郵便番号</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.postal_cd }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>都道府県</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.todohuken_name }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>市区町村以下</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.street_address }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right q-mr-md">
        <label>電話番号</label>
      </div>
      <div class="col">
        <span>{{ props.memberInfo.phone_number }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as UserAttributeCode from '../../../common/code/UserAttributeCode';

interface Props {
  memberInfo: {
    // ユーザー情報
    user_name_sei: string;
    user_name_mei: string;
    mail_address: string;
    mail_address_conf: string;
    user_attribute: UserAttributeCode.default;
    // 所属先情報
    work_school_name: string;
    affiliation_department_name: string;
    postal_cd: string;
    todohuken_name: string;
    street_address: string;
    phone_number: string;
    [key: string]: string;
  };
}
const props = defineProps<Props>();

// 表示時にトップにスクロール
window.scrollTo({
  top: 0,
});
</script>
<style scoped>
.confirmation-form .row .col span {
  word-break: break-all;
  letter-spacing: 1px;
}
</style>
